import containerFuild from '../html-snippets/container-fuild';
import dividerPrimary from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html.js';
import css from '../css-snippets/section-losaprily-card-banner';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';

const dividerPrimaryHtml = dividerPrimary({
  show: true,
  maxWidth: 48,
  height: 4,
  backgroundColor: '#a9acb3',
  align: 'left',
});
const buttonLosaprilyHtml = buttonPrimaryHtml({
  show: true,
  backgroundColor: '#ff0000',
  color: '#FFFFFF',
  radius: 4,
  text: 'I Do',
  link: '#',
  iconPrefix: {
    show: false,
    src: '',
  },
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
  subBtn: {
    show: false,
    text: '',
  },
});

const html = `
<div class="container">
  <div class="wrap-card">
    <div data-attribute="wrap-banner" data-use-banner-mobile="true" class="wrap-banner">
      <img
        data-attribute="banner-desktop-img"
        class="banner-desktop"
        src="https://cdn.skyfastimg.com/images/2026/06/26/image-6a3dfc4a3497f8fd2af949f0.png?w=1000&h=50&q=80"
        alt=""
      />
      <img
        data-attribute="banner-mobile-img"
        class="banner-mobile"
        src="https://cdn.skyfastimg.com/images/2026/06/26/image-6a3e25973655cb3ffeed552e.png?w=1000&h=50&q=80"
        alt=""
      />
      <div data-width-content="625" data-attribute="wrap-content" class="wrap-content" style="--width-content: 625px">
        <div data-attribute="heading-content" data-show="true" class="heading-content">
          <h2><strong>Fun and playful floating seat</strong></h2>
        </div>
        <div data-attribute="divider-content" data-show="true" class="divider-content">${dividerPrimaryHtml}</div>
       <div
          data-attribute="description-content"
          data-show="true"
          class="description-content"
        >
          <p>
            <span>Recommended by parents and family influencers</span>
          </p>
          <p>
            <span>“ The anti-tip design gives me complete peace of mind while playing in
              the pool with my little girl — the perfect and safe water companion.
              ”</span>
          </p>
          <p>
            <span style="font-size: 13px !important">- Lily Carter, Senior Child Safety Expert</span>
          </p>
        </div>
        <div data-attribute="wrap-image-small" data-show="false" class="wrap-image-small">
          <img
            data-attribute="image-small"
            src="https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cffc9c5e4f05cbd90d10f.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
  ${buttonLosaprilyHtml}
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#ffffff',
  textColor: '#000000',
});
